import { render, staticRenderFns } from "./done.vue?vue&type=template&id=87842d9e&scoped=true"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"
import style0 from "./done.vue?vue&type=style&index=0&id=87842d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87842d9e",
  null
  
)

export default component.exports